export default "__VITE_ASSET__BFdJZQ0C__"